import { useMemo } from "react";
import { computeRegisterFilteredStats } from "../utils/registerFilteredStats";
import "./RegisterFilteredStatsPanel.css";

function StatBlock({ label, metric, details = [], wide = false }) {
  return (
    <article
      className={`register-filtered-stats-panel__block${
        wide ? " register-filtered-stats-panel__block--wide" : ""
      }`}
    >
      <h3 className="register-filtered-stats-panel__block-title">{label}</h3>
      <p className="register-filtered-stats-panel__ratio">{metric.ratioLabel}</p>
      <p className="register-filtered-stats-panel__percent">{metric.percentLabel}</p>
      {details.length ? (
        <div className="register-filtered-stats-panel__details">
          {details.map((detail) => (
            <div key={detail.label} className="register-filtered-stats-panel__detail">
              <span className="register-filtered-stats-panel__detail-label">{detail.label}</span>
              <span className="register-filtered-stats-panel__detail-ratio">{detail.metric.ratioLabel}</span>
              <span className="register-filtered-stats-panel__detail-percent">
                {detail.metric.percentLabel}
              </span>
            </div>
          ))}
        </div>
      ) : null}
    </article>
  );
}

export default function RegisterFilteredStatsPanel({ entries = [] }) {
  const stats = useMemo(() => computeRegisterFilteredStats(entries), [entries]);

  return (
    <div className="register-filtered-stats-panel">
      <header className="register-filtered-stats-panel__header">
        <h2 className="register-filtered-stats-panel__title">Statistiques des données filtrées</h2>
        <p className="register-filtered-stats-panel__intro">
          {stats.total.toLocaleString("fr-FR")}{" "}
          {stats.total > 1 ? "mots pris en compte" : "mot pris en compte"}
          {" "}
          dans la liste actuelle.
        </p>
      </header>

      {stats.total === 0 ? (
        <p className="register-filtered-stats-panel__empty">
          Aucun mot disponible pour calculer ces statistiques.
        </p>
      ) : (
        <div className="register-filtered-stats-panel__grid">
          <StatBlock label="Mots maîtrisés" metric={stats.mastered} />
          <StatBlock label="Mots bien restitués" metric={stats.lastCorrect} />
          <StatBlock label="Mots à revoir" metric={stats.review} />
          <StatBlock label="Mots jamais joués" metric={stats.never} />
          <StatBlock
            label="Mots joués 1 ou 2 fois"
            metric={stats.played12}
            wide
            details={
              stats.played12.count > 0
                ? [
                    {
                      label: "Correctement orthographiés au dernier jeu",
                      metric: stats.played12.lastSuccess,
                    },
                    {
                      label: "Mal orthographiés au dernier jeu",
                      metric: stats.played12.lastFail,
                    },
                  ]
                : []
            }
          />
        </div>
      )}
    </div>
  );
}
